import React, { useContext, useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { modalEventListener } from "../../../utils/ModalEventListener";
import { useDropzone } from "react-dropzone";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { maxFileSize } from "../../../utils/constant";
import { axios_instance } from "../../../api/axios_instance";
import { decryptRequest } from "../../../utils/encryptdecryptrequest";
import { DetailPageLoadingModalContext } from "../../../ContextAPI/context";

const UpdateCaseInfoModal = ({
  title,
  closeUpdateCaseInfoModal,
  lead_id,
  checkDownloadCaseInfoPermission,
  checkUpdateCaseInfoPermission,
  toggleCaseConfirmModal,
}) => {
  const [leadId, setLeadId] = useState("");
  const [file, setFile] = useState({});

  const { setShowLoadingModal } = useContext(DetailPageLoadingModalContext);
  const ref = useRef();

  useEffect(() => {
    return modalEventListener(ref, closeUpdateCaseInfoModal);
  }, [closeUpdateCaseInfoModal]);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (files) => {
      if (files.length) {
        setFile(files[0]);
        toast.success(`${files[0].name} has been uploaded, to complete process click on
      "Complete Upload"`);
      } else {
        toast.error("Unsupported format. Please upload a CSV file.");
      }
    },
    accept: { "text/csv": [".csv"] },
    maxFiles: 1,
    maxSize: maxFileSize,
    multiple: false,
  });

  const downloadCaseInfoCSV = async () => {
    toast.dismiss();

    if (leadId === "")
      return toast.error("Please Enter Loan Id", { theme: "colored" });
    if (!leadId.match(/^\d*$/))
      return toast.error("Loan Id should be numeric", { theme: "colored" });
    if (leadId !== lead_id)
      return toast.error("Loan id mismatch with case id", { theme: "colored" });
    try {
      setShowLoadingModal(true);
      const response = await axios_instance({
        url: "/dts/downloadCaseInfo",
        method: "POST",
        data: {
          leadId,
        },
      });

      if (response.status === 200) {
        const { url } = decryptRequest(response?.data?.resData);
        window.open(url);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setShowLoadingModal(false);
    }
  };

  const uploadCaseInfo = async () => {
    toast.dismiss();
    if (!Object.keys(file).length) {
      return toast.error("Please upload the file to proceed");
    }

    try {
      if (!file || !Object.keys(file).length) {
        return toast.error("Please upload the file to proceed", {
          theme: "colored",
        });
      }
      const data = new FormData();
      data.append("file", file);

      setShowLoadingModal(true);
      const response = await axios_instance({
        url: "/dts/updateCaseInfoFile",
        method: "POST",
        data,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status === 200) {
        closeUpdateCaseInfoModal();
        toggleCaseConfirmModal();
      }
    } catch (error) {
      return toast.error(error?.response?.data?.message);
    } finally {
      setShowLoadingModal(false);
    }
  };

  return ReactDOM.createPortal(
    <div className="modal-wrapper" id="modal-wrapper">
      <ToastContainer
        closeOnClick={false}
        draggable={false}
        closeButton={false}
      />
      <div className="updatecaseinfo-modal-content" ref={ref}>
        <div className="modal-header">
          <button
            type="button"
            className="close"
            onClick={closeUpdateCaseInfoModal}
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 className="modal-title" id="">
            {title}
          </h4>
        </div>
        <div className="modal-body clearfix doc-upload-wrapper">
          {checkDownloadCaseInfoPermission ? (
            <div className="form-group clearfix">
              <div className="row">
                <div className="col-md-5 ">
                  <div className="form-group">
                    <input
                      type="text"
                      value={leadId}
                      id="case_info_loan_id"
                      name="case_info_loan_id"
                      className="form-control"
                      placeholder="Enter Loan ID"
                      onChange={(e) => setLeadId(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <button
                    type="button"
                    className="btn btn-primary"
                    id="download_case_info"
                    title="Download Format"
                    onClick={downloadCaseInfoCSV}
                  >
                    <span className="fa fa-download"></span> Download Format
                  </button>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
          {checkUpdateCaseInfoPermission ? (
            <div className="form-group clearfix">
              <div className="row">
                <div className="col-md-5 ">
                  <label className="fnt14">
                    Accepted Format : <span className="col-red">.csv</span>
                  </label>
                </div>
                <div className="col-md-12">
                  <div>
                    <form
                      className="dropzone dd-zone"
                      style={{ minHeight: "180px" }}
                      id="case_info_uploader"
                    >
                      <input
                        type="hidden"
                        name="action"
                        value="upload_caseinfo_document"
                      />
                      <div
                        className="dz-default dz-message"
                        {...getRootProps()}
                      >
                        <input {...getInputProps()} />
                        Drop files here to upload
                      </div>
                    </form>
                    <div className="clearfix btn-upload-wrapper">
                      <div className="ufn-wrapr">
                        <p className="ufn" id="caseInfoUploadDiv">
                          {file.name}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
        {checkUpdateCaseInfoPermission ? (
          <div className="modal-footer text-center">
            <button
              type="button"
              className="btn rc-btn_primary btn-lg"
              id="uploadCaseInfoBtn"
              value=""
              onClick={uploadCaseInfo}
            >
              Complete Upload
            </button>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>,
    document.querySelector(".myPortalModalDiv")
  );
};

export default UpdateCaseInfoModal;
